import React from 'react';
import { SUNDAYS, type SundayKey, type WorshipWeeklyState, avgWorship } from '../../utils/mbcbReportShared';

interface SundayGridProps {
  weekly: WorshipWeeklyState;
  onChange: (sk: SundayKey, value: string) => void;
  disabled?: boolean;
}

export const SundayGrid: React.FC<SundayGridProps> = ({ weekly, onChange, disabled = false }) => {
  const average = avgWorship(weekly);

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-5 gap-2">
        {SUNDAYS.map((sk, idx) => (
          <div key={sk}>
            <label className="block text-[11px] font-medium text-gray-500 text-center mb-1">
              Sun {idx + 1}
            </label>
            <input
              type="number"
              min={0}
              disabled={disabled}
              value={weekly.worshipAttendance[sk] || ''}
              onChange={(e) => onChange(sk, e.target.value)}
              className="block w-full rounded-xl border-gray-200 bg-white text-center text-sm py-2.5 focus:border-primary-500 focus:ring-primary-500 disabled:bg-gray-50 tabular-nums"
              inputMode="numeric"
            />
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between rounded-xl bg-primary-50/60 border border-primary-100 px-4 py-2.5">
        <span className="text-sm text-gray-600">Weekly average</span>
        <span className="text-lg font-semibold text-primary-800 tabular-nums">
          {Math.round(average * 10) / 10}
        </span>
      </div>
    </div>
  );
};
